export default __webpack_public_path__ + "static/media/opening.2254ecd2.png";